// extracted by mini-css-extract-plugin
export var aggregationCell = "_2h-k";
export var aggregationRow = "_2h-j";
export var borderlessSpinnerContainer = "_2h-3";
export var closeIcon = "_2h-c";
export var columnHeaderSurface = "_2h-8";
export var columnHeaderSurfaceDragOverlay = "_2h-s";
export var columnHeaderSurfaceResizing = "_2h-p";
export var contextMenuAnchor = "_2h-1";
export var draggableColumnHeader = "_2h-q";
export var draggableColumnHeaderOverlay = "_2h-r";
export var expandIcon = "_2h-d";
export var expanded = "_2h-e";
export var filterDropdown = "_2h-f";
export var filterDropdownDivider = "_2h-a";
export var filterDropdownHeader = "_2h-i";
export var filterDropdownItem = "_2h-h";
export var filterDropdownModal = "_2h-g _2h-f";
export var filterItem = "_2h-9";
export var normalCellWithAdjustableBorder = "_2h-b";
export var pinButtonContainer = "_2h-l";
export var pinIcon = "_2h-m";
export var pinIconActive = "_2h-n";
export var spinner = "_2h-0";
export var spinnerContainer = "_2h-2";
export var tableContainer = "_2h-4";
export var tableContentDraggingColumns = "_2h-7";
export var tableContentInner = "_2h-6";
export var tableContentWrapper = "_2h-5";
export var viewButtonContainer = "_2h-o";